//deps
import React, { memo, useMemo } from "react";
//components
import { Text } from "@swiggy-private/dls-web-core/dist/components/Text";
import TickIcon from "../../TickIcon";
//styles
import { ContentItemContainer } from "../styles";
//helpers
import { getTitleConfig } from "@super-ui/components/m2c-swiggy-black-halfcard/helpers";
//constants
import { M2C_HALFCARD_TEST_IDS } from "@super-ui/components/m2c-swiggy-black-halfcard/constants";

const ContentItem = ({ title, index, isPopup }: { title: string; index: number; isPopup: boolean }) => {
    const titleConfig = useMemo(() => getTitleConfig(title, true), [title]);
    return (
        <ContentItemContainer
            index={index}
            isPopup={isPopup}
            data-testid={M2C_HALFCARD_TEST_IDS.GRATIFICATION_CONTENT_ITEM}
        >
            <TickIcon />
            <Text
                variant={isPopup ? "V2.body1.neutral.regular" : "V2.body1.neutral.medium"}
                color="primary"
                dangerouslySetInnerHTML={{ __html: titleConfig.title }}
            />
        </ContentItemContainer>
    );
};

export default memo(ContentItem);
